export default function LeagueDescriptionSection() {
    return (
        <section className="rounded-2xl border border-white/10 bg-[#0d121b] p-6 md:p-8">
            <div className="max-w-5xl">
                <p className="text-sm font-black uppercase tracking-[0.22em] text-orange-300">
                    La Ligue des 2 Zéros
                </p>

                <h1 className="mt-3 text-3xl font-black uppercase leading-tight text-white md:text-5xl">
                    Championnat amateur multiculturel au Luxembourg et aux 3 Frontières
                </h1>

                <div className="mt-5 space-y-4 text-base leading-8 text-white/75">
                    <p>
                        La Ligue des 2 Zéros du Luxembourg et des 3 Frontières est un
                        championnat annuel de football amateur qui rassemble des équipes
                        issues du Luxembourg, de la France frontalière et de différentes
                        communautés africaines résidant dans la Grande Région.
                    </p>

                    <p>
                        Cette première édition a pour objectif de créer un espace sportif,
                        culturel et social autour du football. La compétition valorise le
                        fair-play, l’intégration, la fraternité, le respect entre les
                        communautés et la participation des familles autour des matchs.
                    </p>

                    <p>
                        Après plus de 40 matchs joués pendant la saison, les meilleures
                        équipes se retrouvent pour les demi-finales. Cette journée marque
                        une étape importante du championnat, avec un match de gala, deux
                        rencontres décisives et un moment de partage entre joueurs,
                        supporters, partenaires, associations et familles.
                    </p>
                </div>
            </div>
        </section>
    );
}